import * as React from "react";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
import { ILOBCheckbox, TypeMenuProps } from "../../typings";
import { UitkPill } from "uitk-react-pill";
import { UitkSpacing } from "uitk-react-spacing";

interface TypeMenuPillsProps extends TypeMenuProps {
  showMulticity: boolean;
  showOneway: boolean;
  showEnhancedLabels: boolean;
}

export const TypeMenuPillsHotwire = ({
  handleMenuChange,
  lobsMap,
  className,
  useLink,
  lobKeys,
}: TypeMenuPillsProps) => {
  const renderPill = (key: string, { checked, ref, id, label }: ILOBCheckbox) => {
    const checkedIconWithText = (
      <>
        <UitkIcon name="check_circle" size={UitkIconSize.SMALL} /> {label}
      </>
    );
    const overridenLabel = checked ? checkedIconWithText : label;
    const activePillStyle = checked ? "active" : "";

    const onChangePill = () => {
      handleMenuChange(key, ref, id);
    };

    return (
      <UitkPill
        key={key}
        id={!useLink ? `package-pills-${key}` : ""}
        checked={checked}
        active={checked}
        className={activePillStyle}
        onChange={onChangePill}
        children={overridenLabel}
      />
    );
  };

  const pillsToLoad = () => {
    return lobKeys.map((lobKey) => {
      const lobCheckbox: ILOBCheckbox = lobsMap[lobKey];
      const pillToLoad = renderPill(lobKey, lobCheckbox);

      if (useLink) {
        return (
          <UitkSpacing margin={{ inline: "one" }} key={lobKey}>
            <button className="ssr-link-pill">{pillToLoad}</button>
          </UitkSpacing>
        );
      }

      return pillToLoad;
    });
  };

  return (
    <UitkLayoutFlexItem className={className}>
      <div>
        <UitkLayoutFlex data-testid="type-menu-pills">{pillsToLoad()}</UitkLayoutFlex>
      </div>
    </UitkLayoutFlexItem>
  );
};
